import { formatPercentage, formatTextEllipsis, formatTimeAgo, formatValueWithCompactNumber } from '@/lib/format';
import { genJudgingSizeColor } from '@/lib/utils';
import { useAppStore } from '@/store';

interface IProps {
  data: {
    amount: string;
    bought: string;
    price: string;
    timestamp: number;
    walletAddress: string;
    marketCap: string;
    profit: string;
    priceChg: string;
  };
}

export default (props: IProps) => {
  const { data } = props;
  const { fwClass } = useAppStore();

  return (
    <div className="h-[64px] text-[12px] !border-t-[1px] border-borderColor flex items-center">
      <div className="w-[110px]">
        <div>
          <div className={fwClass}>{formatTextEllipsis(data.walletAddress)}</div>
          <div className="text-secondaryTextColor text-[12px]">{formatTimeAgo(data.timestamp, { style: 'shortAgo' })}</div>
        </div>
      </div>
      <div className="w-[77px]">{formatValueWithCompactNumber(data.marketCap, true)}</div>
      <div className="w-[77px]">{formatValueWithCompactNumber(data.bought, true)}</div>
      <div className="w-[77px]">
        <div>
          <div className={genJudgingSizeColor(data.profit)}>{formatValueWithCompactNumber(data.profit)}</div>
          <div className={genJudgingSizeColor(data.profit)}>{formatPercentage(data.priceChg, { scale: true, showPositiveSign: true })}</div>
        </div>
      </div>
    </div>
  );
};
